import React from "react";
import { Loader2 } from "lucide-react";
import useWindowDimensions from "../../hooks/windowsSize";
import { cn } from "../../lib/utils";
import { Button } from "../ui/common/button";

export interface TailwindBottomButtonViewProps {
  customHeight?: number | null;
  deleteStatus?: boolean;
  cancelButtonStatus?: boolean;
  saveButtonStatus?: boolean;
  deleteButton?: () => void;
  saveButton?: () => void;
  cancelButton?: () => void;
  bounceEnable?: boolean;
  cancelButtonTitle?: string;
  saveTitle?: string;
  type?: "button" | "submit" | "reset";
  saveDisable?: boolean;
  saveLoading?: boolean;
  deleteDisable?: boolean;
  cancelDisable?: boolean;
  isSimulation?: boolean;
  customBottomContentMain?: string;
  testId?: string;
  buttonSize?: "default" | "sm" | "lg" | "icon";
}

const TailwindBottomButtonView: React.FC<TailwindBottomButtonViewProps> = ({
  customHeight = null,
  deleteStatus = false,
  cancelButtonStatus = false,
  saveButtonStatus = false,
  deleteButton = () => {},
  saveButton = () => {},
  cancelButton = () => {},
  bounceEnable = false,
  saveTitle = "Save",
  type = "button",
  saveDisable = false,
  saveLoading = false,
  cancelDisable = false,
  deleteDisable = false,
  isSimulation = false,
  cancelButtonTitle = "Cancel",
  customBottomContentMain,
  testId = "main-bottom-button-view",
  buttonSize = "default"
}) => {
  const { height } = useWindowDimensions();
  const heightView = customHeight || height * 0.1;

  return (
    <div
      style={{ height: heightView }}
      className={cn("tw-flex tw-items-center tw-px-6 tw-py-4", customBottomContentMain)}
    >
      <div className="tw-flex tw-w-full tw-flex-col tw-gap-2 md:tw-flex-row md:tw-items-center">
        <div className="tw-flex tw-w-full tw-flex-1 tw-flex-wrap tw-gap-2 md:tw-w-[56%]">
          {cancelButtonStatus && (
            <Button
              type="button"
              variant="outline"
              size={buttonSize}
              onClick={cancelButton}
              disabled={cancelDisable}
              className="tw-border-border tw-text-foreground hover:tw-bg-muted hover:tw-text-foreground"
            >
              {cancelButtonTitle}
            </Button>
          )}
          {deleteStatus && (
            <Button
              type="button"
              variant="outline"
              size={buttonSize}
              onClick={deleteButton}
              disabled={deleteDisable}
              data-testid={`${testId}-delete-button`}
              className="tw-pointer-events-auto tw-border-destructive/40 tw-text-destructive hover:tw-bg-destructive/10 hover:tw-text-destructive"
            >
              Delete
            </Button>
          )}
        </div>
        <div className="tw-flex tw-w-full tw-justify-end md:tw-w-[44%]">
          {saveButtonStatus && !isSimulation && (
            <Button
              type={type}
              size={buttonSize}
              onClick={saveButton}
              disabled={saveDisable || saveLoading}
              className={bounceEnable ? "bounce-effect" : undefined}
              data-testid={`${testId}-save-button`}
            >
              {saveLoading ? (
                <>
                  <Loader2 className="tw-mr-2 tw-h-4 tw-w-4 tw-animate-spin" />
                  Saving...
                </>
              ) : (
                saveTitle
              )}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default TailwindBottomButtonView;
